import * as yup from 'yup';
import { IS_REQUIRED_ERROR_MESSAGE } from './constants';

const requiredStringSchema = yup.string().required(IS_REQUIRED_ERROR_MESSAGE);

export default requiredStringSchema;
